import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TranslationTableMenu from './TranslationTableMenu';
import {
  saveTranslationTable,
  deleteTranslationTable,
  cancelTranslationTable,
  setTranslationTableEditionMode,
  resetTranslationTableEditionMode,
  fetchTranslationTable
} from "redux/translationTable/TranslationTableActions";
import { fetchTranslationTables, deleteUnconfirmedTranslationTableFromList } from "redux/profileTranslationTables/ProfileTranslationTablesActions";

const mapStateToProps = ({ mapping, translationTable, profiles, profileTranslationTables }) => ({
  showColumnLists: mapping.showColumnLists,
  translationTable: translationTable.translationTable,
  translationTables: profileTranslationTables.translationTables,
  unconfirmedTranslationTables: profileTranslationTables.unconfirmedTranslationTables,
  fetchingTranslationTables: profileTranslationTables.fetchingTranslationTables,
  isSavingTranslationTable: translationTable.isSaving,
  translationTableFromCreate: translationTable.translationTableFromCreate,
  profileEditionMode: profiles.profileEditionMode,
  mapId: profiles.profile.mapId,
  translationTableEditionMode: translationTable.translationTableEditionMode,
  fetchingAllTranslationTables: translationTable.fetchingAllTranslationTables
});

const mapDispatchToProps = dispatch => ({
  ttActions: bindActionCreators(
    {
      saveTranslationTable,
      deleteTranslationTable,
      cancelTranslationTable,
      fetchTranslationTable,
      setTranslationTableEditionMode,
      resetTranslationTableEditionMode
    },
    dispatch
  ),
  profileTTActions: bindActionCreators({ fetchTranslationTables, deleteUnconfirmedTranslationTableFromList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TranslationTableMenu);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/translationTableMenu/TranslationTableMenuConnector.js